import { render } from "./SignOut.vue?vue&type=template&id=50ba3db2&scoped=true"
import script from "./SignOut.vue?vue&type=script&lang=js"
export * from "./SignOut.vue?vue&type=script&lang=js"

import "./SignOut.vue?vue&type=style&index=0&id=50ba3db2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/GPSviaAIS/GPSviaAIS/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ba3db2"]])

export default __exports__